/* ==========================================================================
   Force of Nature Genetics - age gate

   Self-declared confirmation. Remembers the answer for a configurable
   number of days in localStorage, with a cookie fallback.

   Deliberate design choices:
     - The overlay is added by JavaScript AFTER the page renders, so search
       engines still crawl the store normally and SEO is unaffected.
     - Focus is trapped inside the dialog and restored on close.
     - Fails OPEN if storage is unavailable (private mode): the gate simply
       shows every visit rather than locking anyone out permanently.

   NOT legal advice - confirm threshold and wording with counsel.
   ========================================================================== */
(function () {
  "use strict";

  var root = document.getElementById("fon-age-gate");
  if (!root) return;

  var KEY = "fon_age_ok";
  var days = parseInt(root.getAttribute("data-remember-days"), 10);
  if (!days || days < 1) days = 30;

  function stored() {
    try {
      var v = window.localStorage.getItem(KEY);
      if (v && parseInt(v, 10) > Date.now()) return true;
    } catch (e) { /* private mode - fall through */ }
    return document.cookie.indexOf(KEY + "=1") !== -1;
  }

  function remember() {
    var until = Date.now() + days * 864e5;
    try { window.localStorage.setItem(KEY, String(until)); } catch (e) {}
    document.cookie = KEY + "=1; path=/; max-age=" + (days * 86400) + "; SameSite=Lax";
  }

  if (stored()) { root.remove(); return; }

  var lastFocus = document.activeElement;
  var lock = document.documentElement;

  function open() {
    root.hidden = false;
    lock.classList.add("fon-ag-locked");
    document.body.classList.add("fon-ag-locked");
    var first = root.querySelector(".fon-ag__btn--yes");
    if (first) first.focus();
    document.addEventListener("keydown", onKey, true);
  }

  function close() {
    lock.classList.remove("fon-ag-locked");
    document.body.classList.remove("fon-ag-locked");
    document.removeEventListener("keydown", onKey, true);
    root.remove();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* trap focus - Escape must NOT dismiss an age gate */
  function onKey(e) {
    if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); return; }
    if (e.key !== "Tab") return;
    var f = root.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  var yes = root.querySelector("[data-fon-ag-yes]");
  var no  = root.querySelector("[data-fon-ag-no]");
  var ask = root.querySelector("[data-fon-ag-ask]");
  var deny = root.querySelector("[data-fon-ag-denied]");

  if (yes) yes.addEventListener("click", function () { remember(); close(); });

  if (no) no.addEventListener("click", function () {
    if (ask) ask.hidden = true;
    if (deny) {
      deny.hidden = false;
      deny.setAttribute("tabindex", "-1");
      deny.focus();
    }
  });

  open();
})();
